<script setup lang="ts">
const {t} = useI18n({
  useScope: "global",
});

const client = useClient();

const {data, status} = await client.balance.balance.useQuery();

const actionCodeByName: Record<string, string> = {
  balance: "showBalanceDetails",
  // overdraft: "showBalanceDetails",
  bonusBalance: "showBonusBalanceDetails",
};

const iconByName: Record<string, string> = {
  balance: "flowbite:cash-outline",
  overdraft: "flowbite:credit-card-outline",
  bonusBalance: "flowbite:gift-box-outline",
};

const openDetails = async (name: string) => {
  const code = actionCodeByName[name];
  if (!code) return;

  const {open} = await useAction({
    input: JSON.stringify({ code }),
  }, {});

  await open();
};
</script>

<template>
  <div
    class="balance"
  >
    <template v-if="status == 'success' && data.show">
      <div
        v-for="item in data.items"
        :key="item.name"
        class="can-click"
        @click="openDetails(item.name)"
      >
        <div class="balance-row">
          <NuxtIcon
            class="balance-icon"
            :name="iconByName[item.name] ?? 'flowbite:cash-outline'"
          />
          <span :title="item.name === 'balance' ? t('account.balance.showBalanceDetails') : undefined">
            <FormatCurrencyColor :value="item.amount" />
          </span>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.balance {
  margin-right: 20px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-color);
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  img {
    margin-right: 10px;
  }

  text-align: right;
}
.balance-row {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
}
.balance-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.can-click {
  cursor: pointer;
  padding: 2px;
  &:hover {
    background-color: #f1f1f1;
    border-radius: 4px;
  }
}
</style>
